import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { Form } from '../../Form/index.js'
import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { slugifyFieldKey } from '../utils/utils.js'

interface Props {
  isNew: boolean
}
export const FieldKeyInput = ({ isNew }: Props) => {
  const { $t } = useI18n()
  const { watch, setValue } = useFormContext()
  const name = watch('name')

  useEffect(() => {
    if (isNew) {
      setValue('key', slugifyFieldKey(name))
    }
  }, [isNew, name, setValue])

  return (
    <Form.Input
      label={$t({
        defaultMessage: 'Key',
        id: 'Admin.CMSFields.FieldKey',
      })}
      name="key"
      helperText={
        isNew
          ? $t({
              defaultMessage:
                'Key is the unique identifier for this field and you will not be able to change it in the future',
              id: 'Admin.CMSFields.FieldKey.HelperText',
            })
          : ''
      }
      validation={
        isNew
          ? {
              required: $t({
                defaultMessage: "This field can't be empty",
                id: 'Generics.Validation.RequiredField',
              }),
              pattern: {
                value: /^[a-zA-Z_]+$/,
                message: $t({
                  defaultMessage: 'Key can only include alphabets, and _',
                  id: 'Admin.CMSFields.Key.Validation.Pattern',
                }),
              },
            }
          : {}
      }
      disabled={!isNew}
    />
  )
}
